<template>
  <StModal :on-close="() => emit(CLOSE)">
    <div class="st-remove-offer">
      <div class="st-remove-offer__header">
        <StIcon
          name="st-warning-circle-filled"
          size="large"
          :icon-props="{ color: '#CC4039' }"
        />
        <StHeadline :level="2"> Ta bort specialerbjudande </StHeadline>
        <p class="st-remove-offer__header__paragraph">
          Är du säker på att du vill ta bort {{ offerName }} från
          {{ organizationNumber }}?
        </p>
      </div>
      <div class="st-remove-offer__buttons">
        <StButton rectangular secondary full-width @click="emit(CLOSE)">
          Avbryt
        </StButton>
        <StButton
          rectangular
          full-width
          @click="emit('remove')"
          :is-loading="isLoading"
        >
          Ta bort
        </StButton>
      </div>
      <StError v-if="errorMessage" :error-message="errorMessage" />
    </div>
  </StModal>
</template>

<script setup>
import { StModal, StButton, StHeadline, StIcon, StError } from "skanetrafiken";
import { CLOSE } from "@/constants";

const emit = defineEmits(["remove", "close"]);

defineProps({
  offerName: {
    type: String,
    required: true,
  },
  organizationNumber: {
    type: String,
    required: true,
  },
  isLoading: Boolean,
  errorMessage: String,
});
</script>

<style lang="scss" scoped>
@import "~skanetrafiken/dist/scss/functions.scss";
@import "~skanetrafiken/dist/scss/breakpoints.scss";
.st-remove-offer {
  font-family: var(--font-primary);

  @include large {
    width: rem-calc(450);
  }

  &__header {
    text-align: center;

    & > :not(:last-child) {
      margin-bottom: rem-calc(24);
    }

    &__paragraph {
      color: var(--text-color-primary);
      line-height: rem-calc(20);
    }
  }

  & > :not(:last-child) {
    margin-bottom: rem-calc(24);
  }

  &__buttons {
    display: flex;
    flex-direction: column-reverse;

    & > :last-child {
      margin-bottom: rem-calc(16);
    }

    @include large {
      flex-direction: row;
      & > :last-child {
        margin-left: rem-calc(16);
        margin-bottom: 0;
      }
    }
  }
}
</style>
